module.exports = __webpack_public_path__ + "static/media/taskPerformed.945ba8f2.svg";